import React from "react";

// Страховка от «чёрного экрана»: любой сбой рендера показывает понятную
// заглушку с кнопкой обновления вместо пустой страницы.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      console.error("App crashed:", error, info);
    } catch { /* noop */ }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center",
        justifyContent: "center", background: "#060A14", color: "#C6D3E6",
        padding: 24, textAlign: "center",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}>
        <div style={{ maxWidth: 420 }}>
          <div style={{ fontSize: 42 }}>😔</div>
          <h1 style={{ fontSize: 20, fontWeight: 800, marginTop: 16 }}>
            Щось пішло не так
          </h1>
          <p style={{ marginTop: 10, fontSize: 14, color: "#9FB0C7", lineHeight: 1.5 }}>
            Спробуйте оновити сторінку. Якщо не допомогло — напишіть у підтримку, ми все виправимо.
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 20 }}>
            <button onClick={() => window.location.reload()}
              style={{
                background: "linear-gradient(135deg,#2BA8FF,#1E86E8)", color: "#fff",
                border: 0, borderRadius: 14, padding: "12px 20px",
                fontWeight: 700, fontSize: 14, cursor: "pointer",
              }}>
              Оновити сторінку
            </button>
            <a href="https://t.me/episnyasupport" target="_blank" rel="noopener noreferrer"
              style={{
                border: "1px solid rgba(255,255,255,.18)", color: "#C6D3E6",
                borderRadius: 14, padding: "12px 20px", fontWeight: 700,
                fontSize: 14, textDecoration: "none",
              }}>
              Підтримка
            </a>
          </div>
        </div>
      </div>
    );
  }
}
